import React, {FC} from "react";
import {isFundRaising, isLoanPayment, isOverdue, isPaid, isRefunded, OwnedProject} from "api-client";
import {Money as MoneyComponent} from "components/common";
import {formatDate, formatPercents} from "../../../../../../formatters";
import styles from '../../MyOwnedProject.module.scss';

interface MetaSectionProps {
  project: OwnedProject;
}

interface MetaConfig {
  loanLabel: string;
  dateLabel: string;
}

const getMetaConfig = (project: OwnedProject): MetaConfig => {
  if (isFundRaising(project.status)) {
    return {
      loanLabel: "Размер займа",
      dateLabel: "Сбор до"
    };
  }

  if (isLoanPayment(project.status)) {
    return {
      loanLabel: "Остаток займа",
      dateLabel: "Дата погашения"
    };
  }

  if (isPaid(project.status)) {
    return {
      loanLabel: "Остаток займа",
      dateLabel: "Дата погашения"
    };
  }

  if (isOverdue(project.status)) {
    return {
      loanLabel: "Остаток займа",
      dateLabel: "Дата погашения"
    };
  }

  if (isRefunded(project.status)) {
    return {
      loanLabel: "Остаток займа",
      dateLabel: "Дата погашения"
    };
  }

  return {
    loanLabel: "Размер займа",
    dateLabel: "Сбор до"
  };
};

export const MetaSection: FC<MetaSectionProps> = ({project}) => {
  const config = getMetaConfig(project);

  return (
    <div className={styles.myOwnedProject__meta}>
      <div className={styles.myOwnedProject__metaItem}>
        <div className={styles.myOwnedProject__rowHeader}>{config.loanLabel}</div>
        <MoneyComponent money={project.targetSum} />
      </div>

      <div className={styles.myOwnedProject__metaItem}>
        <div className={styles.myOwnedProject__rowHeader}>Ставка договора</div>
        <span>{formatPercents(project.interestRate)}</span>
      </div>

      <div className={styles.myOwnedProject__metaItem}>
        <div className={styles.myOwnedProject__rowHeader}>Срок займа</div>
        <span>{project.initialTerm.toFixed(0)} мес.</span>
      </div>

      <div className={styles.myOwnedProject__metaItem}>
        <div className={styles.myOwnedProject__rowHeader}>{config.dateLabel}</div>
        <span>{project.maturityDate ? formatDate(project.maturityDate) : "—"}</span>
      </div>
    </div>
  );
};








